import { render, staticRenderFns } from "./ModalShareFb.vue?vue&type=template&id=d2481a94&scoped=true&"
import script from "./ModalShareFb.vue?vue&type=script&lang=js&"
export * from "./ModalShareFb.vue?vue&type=script&lang=js&"
import style0 from "./ModalShareFb.vue?vue&type=style&index=0&id=d2481a94&lang=scss&scoped=true&"
import style1 from "./ModalShareFb.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2481a94",
  null
  
)

export default component.exports